/*
 * @Author: Wang Bingjing
 * @Date: 2021-02-22 15:27:48
 * @LastEditTime: 2021-05-12 13:34:01
 * @LastEditors: zhengfan
 */

import {Notification} from '@alifd/next'
const defaultDateFormat = 'YYYY-MM-DD HH:mm:ss';

export function encryption(value) {
    if(!value) return '';

    // 安全 btoa（UTF-8 转换）
    const safeBtoa = (str) => btoa(unescape(encodeURIComponent(str)));
    const firstEncrypt = safeBtoa(value);
    const secondEncrypt = safeBtoa(`${firstEncrypt}LifeIsSoDeepppp`);
    return secondEncrypt;
}
export function debounce(func, wait=500, immediate) {
	let timeout;
	return function executedFunction() {
		const context = this;
		const args = arguments;
		const later = function () {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		const callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
}

// Filters the null/undefined/'' values in the object
export function filterEmptyValue(obj) {
	const newObj = {};
	if (obj === null || obj === undefined || obj === '') return newObj;
	for (const key in obj) {
		if (obj[key] !== null && obj[key] !== undefined && obj[key] !== '') {
			newObj[key] = obj[key];
		}
	}
	return newObj;
}

// Splice the request string according to the request object parameters
export function getRequestParamsStr(paramsObj) {
	let urlString = '';
	if (paramsObj && Object.keys(paramsObj).length > 0) {
		Object.keys(paramsObj).forEach((key, index) => {
			const value = paramsObj[key];
			if(value || value===false || value===0) {
				if(key ==='startTime' || key ==='endTime' || key ==='start_time' || key ==='end_time' ){
					urlString = urlString === '' ? 
					`?${key}=${value.format(defaultDateFormat)}`:
					`${urlString}&${key}=${value.format(defaultDateFormat)}`;
				}else{
					urlString = urlString === '' ? `?${key}=${value}`:`${urlString}&${key}=${value}`;
				}
			}
		});
	}
	return urlString;
}

export function generateDateList(startDate, endDate) {  
	// 将日期字符串转换为 Date 对象  
	const start = new Date(startDate);  
	const end = new Date(endDate);
	  
	// 初始化结果列表  
	const dateList = [];  
	  
	// 设置当前日期为开始日期  
	let current = new Date(start);
	  
	// 当当前日期小于等于结束日期时，循环继续  
	while (current <= end) {  
		// 获取当前年份和月份  
		const year = current.getFullYear();  
		const month = current.getMonth() + 1; // getMonth() 返回的是 0-11，需要加 1  
		  
		// 查找当前年份的对象，如果不存在则创建  
		let yearObj = dateList.find(obj => obj.year === year);  
		if (!yearObj) {  
			yearObj = { year, month: [] };  
			dateList.push(yearObj);  
		}  
		  
		// 将月份添加到当前年份的对象中  
		if (!yearObj.month.includes(month)) {  
			yearObj.month.push(month);  
		}  
		  
		// 将当前日期设置为下一个月的第一天  
		current.setMonth(current.getMonth() + 1);  
		current.setDate(1);  
	}  
	// 获取数组中最后一个对象的引用  
	// const lastItem = dateList[dateList.length - 1];  
	// 在最后一个对象的 month 字段的数组中添加一个月份
	// lastItem.month.push(lastItem.month.length + 1);  
	  
	return dateList;  
}

// 获取一个月有多少天
export function getDaysInMonth(date = new Date()) {  
    // 设置日期为下个月的第0天，这样它就会自动回滚到本月的最后一天  
    date.setMonth(date.getMonth() + 1, 0);  
    return date.getDate();  
} 

//boolean(keys) ==> true
export function isEmpty(keys) {
	if (typeof (keys) === 'string') {
		keys = keys.replace(/(^\s*)|(\s*$)/g, '');
		if (keys == '' || keys == null || keys == 'null' || keys == undefined || keys == 'undefined') {
			return true;
		}
		return false;
	} if (typeof (keys) === 'undefined') {
		return true;
	}
	if (typeof (keys) === 'object') {
		for (const i in keys) {
			return false;
		}
		return true;
	}
}


//alert
export function showNote(content, type = 'error', duration = 5000, title = '') {
	Notification.open({
		title,
		duration,
		content,
		type,
	});
}

export function emptyFun() {}

export function guid() {
	function s4() {
		return Math.floor((1 + Math.random()) * 0x10000)
			.toString(16)
			.substring(1);
	}
	return `${s4() + s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
}

export function handleError(err) {
    console.error(err);
    return Promise.reject(err);
  }